import { type OpenApiGetLightProductCardsByRequestRequest } from '#shared/api/schema';
import { DEFAULT_PAGE } from '#shared/components/grid';
import {
    ADDITIONAL_PRODUCTS_GALLERY_MAX_CARDS,
    ADDITIONAL_PRODUCTS_MANUAL_MODE,
    ADDITIONAL_PRODUCTS_SOURCE_MODE,
    type AdditionalProductsFormValue,
} from './constants';
import { mapFormStateToSimilarCardsSettings } from './mapFormStateToPutPayload';

type AdditionalProductsSearchPayloadParams = {
    cardId: string;
    formValue: AdditionalProductsFormValue;
    categorySlugs?: string[];
    collectionSlugs?: string[];
};

const DEFAULT_STATUSES: OpenApiGetLightProductCardsByRequestRequest['statuses'] = ['PUBLISHED', 'HIDDEN'];

export function getAdditionalProductsSearchPayload({
    cardId,
    formValue,
    categorySlugs = [],
    collectionSlugs = [],
}: AdditionalProductsSearchPayloadParams): Pick<
    OpenApiGetLightProductCardsByRequestRequest,
    'page' | 'per_page' | 'statuses' | 'product_list_id' | 'category_slugs' | 'collection_slugs' | 'ai_recommendation'
> | null {
    if (formValue.sourceMode === ADDITIONAL_PRODUCTS_SOURCE_MODE.AI) {
        return {
            page: DEFAULT_PAGE,
            per_page: ADDITIONAL_PRODUCTS_GALLERY_MAX_CARDS,
            statuses: DEFAULT_STATUSES,
            ai_recommendation: cardId,
        };
    }

    const settings = mapFormStateToSimilarCardsSettings(formValue);

    if (!settings) {
        return null;
    }

    if (settings.binding_mode === ADDITIONAL_PRODUCTS_MANUAL_MODE.ALL) {
        return {
            page: DEFAULT_PAGE,
            per_page: ADDITIONAL_PRODUCTS_GALLERY_MAX_CARDS,
            statuses: DEFAULT_STATUSES,
        };
    }

    if (settings.binding_mode === ADDITIONAL_PRODUCTS_MANUAL_MODE.SELECTED) {
        if (!settings.binding.product_list_id) {
            return null;
        }

        return {
            page: DEFAULT_PAGE,
            per_page: ADDITIONAL_PRODUCTS_GALLERY_MAX_CARDS,
            statuses: DEFAULT_STATUSES,
            product_list_id: settings.binding.product_list_id,
        };
    }

    if (categorySlugs.length === 0 && collectionSlugs.length === 0) {
        return null;
    }

    return {
        page: DEFAULT_PAGE,
        per_page: ADDITIONAL_PRODUCTS_GALLERY_MAX_CARDS,
        statuses: DEFAULT_STATUSES,
        ...(categorySlugs.length > 0 ? { category_slugs: categorySlugs } : {}),
        ...(collectionSlugs.length > 0 ? { collection_slugs: collectionSlugs } : {}),
    };
}
